/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyleposter3Inputs */

const en_aiflowstyleposter3 = /** @type {(inputs: Aiflowstyleposter3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poster`)
};

const de_aiflowstyleposter3 = /** @type {(inputs: Aiflowstyleposter3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poster`)
};

/**
* | output |
* | --- |
* | "Poster" |
*
* @param {Aiflowstyleposter3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyleposter3 = /** @type {((inputs?: Aiflowstyleposter3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyleposter3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyleposter3(inputs)
	return de_aiflowstyleposter3(inputs)
});
export { aiflowstyleposter3 as "aiFlowStylePoster" }